import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { fetchDataVitalSign } from '../../store'
import { STORAGE_TOKEN_KEY } from '../../api/constant'

export default function useFetchVitalSignMedical(medicalID, params, setLoading, setRecoil) {
  const history = useHistory()

  useEffect(() => {
    let isApiSubscribed = true
    if (isApiSubscribed) {
      setLoading(true)

      fetchDataVitalSign(params, medicalID, (data, err) => {
        if (data) {
          setRecoil(data)
          setLoading(false)
          isApiSubscribed = false
        } else {
          if (err.redirect) {
            localStorage.removeItem(STORAGE_TOKEN_KEY)
            history.push('/login')
            setLoading(false)
            isApiSubscribed = false
          }
        }
      })
    }

    return () => {
      // cancel the subscription
      isApiSubscribed = false
    }
  }, [medicalID, params, setRecoil, history, setLoading])
}
